{
  "name": "ensemble-fitness",
  "version": "0.19.1",
  "private": true,
  "type": "module",
  "engines": {
    "node": ">=22.13.0"
  },
  "scripts": {
    "dev": "vite --host 127.0.0.1",
    "lint": "tsc -b",
    "build": "tsc -b && vite build",
    "build:ovh": "pnpm build && node scripts/assemble-ovh.mjs",
    "test": "node --test tests/*.test.mjs",
    "preview": "vite preview --host 127.0.0.1"
  },
  "dependencies": {
    "@ensemble/design-tokens": "workspace:*",
    "@ensemble/ui": "workspace:*",
    "lucide-react": "1.28.0",
    "react": "19.2.6",
    "react-dom": "19.2.6"
  },
  "devDependencies": {
    "@types/react": "19.2.14",
    "@types/react-dom": "19.2.3",
    "@vitejs/plugin-react": "6.0.2",
    "typescript": "5.9.3",
    "vite": "8.0.13"
  },
  "packageManager": "pnpm@11.19.0"
}
